<template>
    <pendo-multiselect
        :value="rule.operator"
        :allow-empty="false"
        :preselect-first="true"
        :options="filteredOperators || []"
        :disabled="!filteredOperators || readOnly"
        min-trigger-width="100%"
        value-key="value"
        class="rule-editor--operator"
        @select="$emit('input', { field: 'operator', value: $event })" />
</template>

<script>
import { PendoMultiselect } from '@pendo/components';
import { SEGMENT_OPERATORS } from '@/segments/components/segment-editor-vue/adopt-segment-builder/constants/segments';
import ReadOnlyMixin from '@/segments/components/segment-editor-vue/adopt-segment-builder/rule-mixins/read-only.mixin';

export default {
    name: 'OperatorPicker',
    components: { PendoMultiselect },
    mixins: [ReadOnlyMixin],
    props: {
        operators: {
            type: Object,
            default: null,
        },
        rule: {
            type: Object,
            required: true,
        },
    },
    emits: ['input'],
    computed: {
        schema () {
            return this.rule.schema.schema;
        },
        filteredOperators () {
            const baseOperators = this.operators || SEGMENT_OPERATORS;

            if (!baseOperators[this.schema]) {
                return [];
            }
            if (this.rule.schema.id === 'resourceCenter') {
                return baseOperators[this.schema].filter((op) => op.value !== 'lastviewed');
            }

            return SEGMENT_OPERATORS[this.schema];
        },
    },
};
</script>
